import { goBack } from 'connected-react-router';
import _findIndex from 'lodash/findIndex';
import {
  showLoader, hideLoader, showSnackbar,
} from 'containers/store';
import ApiManager from 'utils/ApiManager';
import PromiseAll from 'utils/PromiseAll';
import snackbarMessages from 'utils/snackbarMessages';

import { finishActiveSurvey, goToActiveSurvey } from 'containers/Dashboard/store';

export const initialState = {
  isLoadedPage: false,
  items: [],
  originalActiveSurveys: [],
  surveys: [],
};

export const actionTypes = {
  LOAD_PAGE_SUCCESS: 'SURVEYS_LIST/LOAD_PAGE_SUCCESS',
  SET_ITEMS: 'SURVEYS_LIST/SET_ITEMS',
  UNSET_ACTIVE_SURVEYS: 'SURVEYS_LIST/UNSET_ACTIVE_SURVEYS',
  UPDATE_SURVEYS: 'SURVEYS_LIST/UPDATE_SURVEYS',
};

const generateItems = (items) => items.map((el, key) => ({
  id: key + 1,
  surveyId: el.survey_id,
  name: el.name,
}));

const generateSurveys = (items) => items.map((el) => ({
  id: el.id,
  name: el.survey.name,
  organization: el.organization.name,
  organizationUnit: el.organization_unit_code,
  numberOfSurveys: el.number_of_surveys,
  surveyStatus: el.active ? 'ACTIVE' : 'ENDED',
  hasAudioEnabled: el.has_audio_enabled || false,
}));

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PAGE_SUCCESS: {
      return {
        ...state,
        isLoadedPage: true,
        items: generateItems(action.responses.surveyList.data),
        originalActiveSurveys: action.responses.activeSurveys.data,
        surveys: generateSurveys(action.responses.surveys.data),
      };
    }

    case actionTypes.UNSET_ACTIVE_SURVEYS: {
      const activeSurveys = [...state.activeSurveys];
      const originalActiveSurveys = [...state.originalActiveSurveys];
      const itemIndex = _findIndex(activeSurveys, (el) => el.id === action.id);
      const originalItemIndex = _findIndex(originalActiveSurveys, (el) => el.id === action.id);
      activeSurveys.splice(itemIndex, 1);
      originalActiveSurveys.splice(originalItemIndex, 1);

      return {
        ...state,
        activeSurveys,
        originalActiveSurveys,
      };
    }

    case actionTypes.UPDATE_SURVEYS: {
      return {
        ...state,
        surveys: generateSurveys(action.response.data),
      };
    }

    default:
      return state;
  }
};

const loadPageSuccess = (responses) => ({
  type: actionTypes.LOAD_PAGE_SUCCESS,
  responses,
});

const unsetActiveSurveys = (id) => ({
  type: actionTypes.UNSET_ACTIVE_SURVEYS,
  id,
});

const updateSurveys = (response) => ({
  type: actionTypes.UPDATE_SURVEYS,
  response,
});

const loadSurveys = (organizationId) => (dispatch) => ApiManager.request('get', dispatch, `organization/${organizationId}/surveys`);

const getActiveSurveys = () => (dispatch) => ApiManager.request('get', dispatch, 'surveys');

const getSurveys = () => (dispatch) => ApiManager.request('get', dispatch, 'surveys/complex');

export const onActiveSurveyClick = (id) => (dispatch, getStore) => {
  const store = getStore();

  dispatch(goToActiveSurvey(id, store.SurveysList.originalActiveSurveys, store.Dashboard.items));
};

export const onActiveSurveyFinish = (id) => (dispatch) => {
  dispatch(finishActiveSurvey(id)).then(() => {
    dispatch(getSurveys()).then((response) => {
      dispatch(updateSurveys(response));
    }).catch(() => {
      dispatch(showSnackbar(snackbarMessages.globalError));
    });
    dispatch(unsetActiveSurveys(id));
  }).catch(() => {});
};

export const loadPageData = () => (dispatch, getStore) => {
  dispatch(showLoader());

  const store = getStore();
  const organizationId = store.Global.selectedOrganization.organizationId;

  PromiseAll({
    surveyList: dispatch(loadSurveys(organizationId)),
    activeSurveys: dispatch(getActiveSurveys()),
    surveys: dispatch(getSurveys()),
  }).then((responses) => {
    dispatch(loadPageSuccess(responses));
    dispatch(hideLoader());
  }).catch(() => {
    dispatch(showSnackbar(snackbarMessages.globalError));
    dispatch(hideLoader());
    dispatch(goBack());
  });
};
